import { FC, useState } from "react";

import { ReactComponent as EyeCloseIcon } from "assets/images/common/eye-closed.svg";
import { ReactComponent as EyeOpenIcon } from "assets/images/common/eye-open.svg";

import TextInput, { TextInputPropsType } from "../TextInput";

const PasswordInput: FC<TextInputPropsType> = (props) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleToggle = () => setIsVisible((prevState) => !prevState);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    handleToggle();
  };

  return (
    <TextInput
      {...props}
      type={isVisible ? "text" : "password"}
      afterIcon={<span onClick={handleClick}>{isVisible ? <EyeOpenIcon /> : <EyeCloseIcon />}</span>}
    />
  );
};

export default PasswordInput;
